import React, { useState } from "react";
import AddCreditCardModal from "./addCreditCardModal";
import { cx } from "../../Util/classHelpers";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import { useFetchCardsQuery, useDeleteCardMutation } from "../../Apis/cardApi";
import { useFetchPaymentSourcesQuery } from "../../Apis/paymentSourceApi";

const getCardsText = (count) => {
  if (count === 0) {
    return "No credit card information found";
  } else if (count === 1) {
    return "1 card added";
  } else {
    return `${count} cards added`;
  }
}

const PARTNER_CREDIT_CARD_INFO = "PARTNER_CREDIT_CARD_INFO";
const PARTNER_CREDIT_UPDATE_CARD_STATE = "PARTNER_CREDIT_CARD_STATE";
const CARD_UPDATE_STATES = {
  pending: "PENDING",
  none: "NONE",
  success: "SUCCESSFUL",
  failed: "FAILED",
};

const CreditCardInfoSection = () => {
  const { data: cardsData, isLoading } = useFetchCardsQuery();
  const { data: paymentSources } = useFetchPaymentSourcesQuery();
  const [deleteCard] = useDeleteCardMutation();
  const [showModal, setShowModal] = useState(false);

  const handleAddCreditCard = () => {
    setShowModal(true);
  };

  const handleRemoveCard = async (id) => {
    try {
      await deleteCard(id).unwrap();
    } catch (error) {
      console.error("Failed to delete card:", error);
    }
  };

  if (!cardsData) {
    return <></>;
  }

  const cards = cardsData.getCards();
  const showLoading = isLoading;

  return (
    <div className={cx("mt-2 paymentMethod position-relative", showLoading && "disabled-div")}>
      <div className="container-fluid sd-shadow">
        <div
          className="row mt-3 mx-5 align-items-center credit-card-info-holder"
          style={{ minHeight: 48 }}
        >
          <div className="col-4 text-start fw-bold">Credit Card</div>
          <div className="col-4 fw-light" style={{ color: "#888" }}>
            <span className="sub-text">{getCardsText(cards.length)}</span>
          </div>
          <div className="col-4 text-end">
            <span
              type="button"
              className="text-btn text-btn-update"
              data-bs-toggle="modal"
              data-bs-target="#creditCardAddModal"
              onClick={handleAddCreditCard}
            >
              Add Card
            </span>
          </div>
        </div>
        <div className="mb-3 mx-5">
          {cards.map((card, idx) => {
            const companies = paymentSources?.getCompaniesWithCard(card.getId()) ?? [];
            return (
            <>
              <hr className="my-2 text-muted" />

              <div
                key={card.getId()}
                className="row align-items-center p-2"
                style={{ minHeight: 48 }}
              >
                <div className="col-3">
                  Ending in <span className="fw-bold">{card.getLast4()}</span>
                </div>
                <div className="col-3">
                  Expires in <span className="fw-bold">{card.getExp()}</span>
                </div>
                <div className="col-3 text-end">
                  Assigned to{" "}
                  <span className="fw-bold">{companies.length}</span>{" "}
                  {companies.length === 1 ? "business" : "businesses"}
                </div>
                <div className="col-3 text-end">
                  <span
                    type={companies.length > 0 ? "span" : "button"}
                    className={cx(companies.length > 0 ? "text-muted" : "text-btn")}
                    disabled={companies.length > 0}
                    onClick={companies.length > 0 ? null : () => handleRemoveCard(card.getId())}
                  >
                    Remove
                  </span>
                </div>
              </div>
            </>
          )})}
        </div>
        <AddCreditCardModal
          isUpdate={false}
          show={showModal}
          setShow={setShowModal}
        />
      </div>
      {showLoading && <LoadingSpinner />}
    </div>
  );
};

export default CreditCardInfoSection;
export {
  PARTNER_CREDIT_CARD_INFO,
  PARTNER_CREDIT_UPDATE_CARD_STATE,
  CARD_UPDATE_STATES,
};
